export default "__VITE_ASSET__DHmc2CTe__"